import { AUDIOCODES_URL } from "@/lib/shared";

const Partner = () => (
  <section
    className="cn-section cn-section-dark"
    id="socio"
    data-testid="partner-section"
  >
    <div className="cn-container cn-partner">
      <p className="cn-eyebrow cn-eyebrow-light" data-reveal>
        SOCIO ESTRATÉGICO
      </p>
      <h2
        className="cn-h2 cn-h2-light"
        data-reveal
        data-testid="partner-headline"
      >
        AudioCodes: la tecnología detrás de la infraestructura
      </h2>
      <p className="cn-partner-body" data-reveal data-testid="partner-body">
        AudioCodes es socio tecnológico clave en toda la infraestructura de
        Caruna, respaldando servicios como grabación inteligente, enrutamiento
        directo y conectividad SIP/TDM. Su tecnología potencia la integración
        con Microsoft Teams, Zoom Phone y Cisco Webex, permitiendo una
        comunicación segura, escalable y totalmente unificada en la nube.
      </p>
      <img
        src={AUDIOCODES_URL}
        alt="AudioCodes"
        loading="lazy"
        className="cn-partner-logo"
        data-testid="partner-logo"
        data-reveal
      />
    </div>
  </section>
);

export default Partner;
